/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindSpotList } from '../../models/find-spot-list';

export interface LegacyGetFindSpotList$Params {

/**
 * GUID of the document
 */
  documentId: string;

/**
 * GUID of the search
 */
  searchId: string;
}

export function legacyGetFindSpotList(http: HttpClient, rootUrl: string, params: LegacyGetFindSpotList$Params, context?: HttpContext): Observable<StrictHttpResponse<FindSpotList>> {
  const rb = new RequestBuilder(rootUrl, legacyGetFindSpotList.PATH, 'get');
  if (params) {
    rb.path('documentId', params.documentId, {});
    rb.path('searchId', params.searchId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindSpotList>;
    })
  );
}

legacyGetFindSpotList.PATH = '/legacy/document/{documentId}/search/{searchId}/find-spot/list';
